import Amplify from 'aws-amplify';
import '@aws-amplify/ui-vue';
import aws_exports from '../aws-exports';

Amplify.configure(aws_exports);





import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import ContactForm from './contactform.vue'
import VueCoreVideoPlayer from 'vue-core-video-player'


// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueCoreVideoPlayer)

new Vue({
  render: h => h(ContactForm),
}).$mount('#app')


